"use client";

import React from "react";
import BaseTailoringQuestions, { TailoringQuestion } from "../../shared/BaseTailoringQuestions";

interface PCLTailoringQuestionsProps {
  onBack?: () => void;
}

const TAILORING_QUESTIONS: TailoringQuestion[] = [
  {
    id: "PCL-1",
    question: "Does the entity have any provisions as at period-end?",
    type: "radio",
    options: ["Yes", "No"],
    follow_up: {
      condition: "Yes",
      id: "PCL-1-doc",
      question: "Document the types of provisions (e.g., restructuring, restoration, etc.)",
      type: "text",
    },
  },
  {
    id: "PCL-2",
    question: "Does the entity have any contingent liabilities as at period-end?",
    type: "radio",
    options: ["Yes", "No"],
    follow_up: {
      condition: "Yes",
      id: "PCL-2-doc",
      question: "Document the nature of contingent liabilities",
      type: "text",
    },
  },
  {
    id: "PCL-3",
    question: "Does the management use an expert for estimating provisions?",
    type: "radio",
    options: ["Yes", "No"],
    follow_up: {
      condition: "Yes",
      id: "PCL-3-doc",
      question: "Document the evaluation of the expert's competence, capabilities and objectivity, understanding of their work, and evaluation of the appropriateness of their work as audit evidence",
      type: "text",
    },
  },
  {
    id: "PCL-4",
    question: "Are there any significant accounting estimates relating to provisions?",
    type: "radio",
    options: ["Yes", "No"],
    follow_up: {
      condition: "Yes",
      id: "PCL-4-doc",
      question: "Document the assessment of estimation uncertainty and management bias",
      type: "text",
    },
  },
];

export default function PCLTailoringQuestions({ onBack }: PCLTailoringQuestionsProps) {
  return (
    <BaseTailoringQuestions
      areaName="Provisions & Contingent Liabilities"
      title="Provisions & Contingent Liabilities - Tailoring Questions"
      description="Customize the audit program for Provisions & Contingent Liabilities"
      questions={TAILORING_QUESTIONS}
      onBack={onBack}
    />
  );
}



